import React from 'react';
import classnames from 'classnames';
import * as styles from './textarea.scss';
import MyMenigoIcon from '../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import { translate } from 'Shared/translate';
export default (props) => {
    const inputProps = Object.assign({}, props, {
        className: classnames(styles.base, props.className),
    });
    return (React.createElement(React.Fragment, null,
        !!props.label && React.createElement("label", { className: classnames(styles.inputLabel), htmlFor: props.id },
            props.label,
            " ",
            !!props.required && React.createElement("span", null, "*")),
        React.createElement("textarea", Object.assign({}, inputProps)),
        React.createElement("span", { className: styles.requiredField },
            React.createElement(MyMenigoIcon, { name: "alert" }),
            translate('/MyMenigo/Accounts/RequiredField'))));
};
